// extracted by mini-css-extract-plugin
module.exports = {"root":"Card_root__AyVvB","content":"Card_content__10BfU","footer":"Card_footer__3v9CU","loading":"Card_loading__jh_Xg","spin":"Card_spin__1GjJm"};